import { inject, Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { BehaviorSubject, from, Subject, Subscription } from 'rxjs';
import { ContextMembership, FirestoreUser, NetworkConstants, fallbackSettingsMap, DistrictReporting, Context, rightsPerRole} from 'diwimamodelweb/lib'
import { TransactionLogService } from './transaction-log.service';
import { diffObject, updatesToFirestoreUpdates, deepCopy, isArray } from 'diwimamodelweb/lib/utils/obejct-diff';
import { UserService } from './user.service';
import { distinctUntilChanged, skipWhile, take, takeUntil, timeout } from 'rxjs/operators';
import * as deepEqual from 'deep-equal'
import { UserFeedbackService } from './user-feedback.service';
import { collection, collectionData, collectionGroup, doc, docData, Firestore, getDoc, getDocs, query, setDoc, updateDoc, where } from '@angular/fire/firestore';
import { saveSelection } from './utils/utils';


@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  private Ifirestore = inject(Firestore);

  ngUnsubscribe: Subject<void> = new Subject<void>();
  subscriptions: Map<string,Subscription> = new Map([])

  allUserContexts$ = new BehaviorSubject<ContextMembership[]>(undefined)
  selectedUserContext$ = new BehaviorSubject<ContextMembership>(undefined)
  lastContextSelected$ = new BehaviorSubject<string>(undefined)
  subbedContext: string|undefined = undefined

  allReportingContexts$ = new BehaviorSubject<DistrictReporting[]>(undefined)

  fallbackGameLocations = fallbackSettingsMap.get(NetworkConstants.SETTING_GR_LOCATION)
  settingsGameLocations: BehaviorSubject<any> = new BehaviorSubject(undefined)
  fallbackGameStatus = fallbackSettingsMap.get(NetworkConstants.SETTING_GR_STATUS)
  settingsGameStatus: BehaviorSubject<any> = new BehaviorSubject(undefined)  
  fallbackSampleStatus = fallbackSettingsMap.get(NetworkConstants.SETTING_LAB_SAMPLE_STATUS)
  settingsSampleStatus: BehaviorSubject<any> = new BehaviorSubject(undefined)
  fallbackSampleLocation = fallbackSettingsMap.get(NetworkConstants.SETTING_LAB_SAMPLE_LOCATION)
  settingsSampleLocation: BehaviorSubject<any> = new BehaviorSubject(undefined)
  fallbackSampleType = fallbackSettingsMap.get(NetworkConstants.SETTING_LAB_SAMPLE_TYPE)
  settingsSampleType: BehaviorSubject<any> = new BehaviorSubject(undefined)
  fallbackHuntingMethods = fallbackSettingsMap.get(NetworkConstants.SETTING_HUNTING_METHODS)
  settingHuntingMethods = new BehaviorSubject<any>(undefined)
  fallbackCollectiveSpecies = fallbackSettingsMap.get(NetworkConstants.SETTING_COLLECTIVE_SPECIES)
  settingCollectiveSpecies = new BehaviorSubject<any>(undefined)
  fallbackTrophyType = fallbackSettingsMap.get(NetworkConstants.SETTING_TROPY_TYPE)
  settingTrophyType = new BehaviorSubject<any>(undefined)
  fallbackMeatQualities = fallbackSettingsMap.get(NetworkConstants.SETTING_GR_MEAT_QUALITY)
  settingMeatQualitySubject = new BehaviorSubject<any>(undefined)
  fallbackShotQualities = fallbackSettingsMap.get(NetworkConstants.SETTING_GR_SHOT_QUALITY)
  settingShotQualitySubject = new BehaviorSubject<any>(undefined)
  fallbackUtilizationOption = fallbackSettingsMap.get(NetworkConstants.SETTING_UTILIZATION_OPTION)
  settingUtilizationOption = new BehaviorSubject<any>(undefined)
  fallbacSpecies = fallbackSettingsMap.get(NetworkConstants.SETTING_SPECIES)
  settingSpecies = new BehaviorSubject<any>(undefined)
  fallbackPoiType = fallbackSettingsMap.get(NetworkConstants.SETTING_GEO_TYPE)
  settingPoiType = new BehaviorSubject<any>(undefined)
/// ----- Poi category
  fallbackPoiCategory = fallbackSettingsMap.get(NetworkConstants.SETTING_GEO_CATEGORY)
  settingPoiCategory = new BehaviorSubject<any>(undefined)
/// ------

  fallbackGeoObjectLineType = fallbackSettingsMap.get(NetworkConstants.SETTING_GEO_LINE_TYPES)
  settingGeoObjectLineType = new BehaviorSubject<any>(undefined)

  fallbackGeoObjectPolygonType = fallbackSettingsMap.get(NetworkConstants.SETTING_GEO_POLYGON_TYPES)
  settingGeoObjectPolygonType = new BehaviorSubject<any>(undefined)

  fallbackGeoObjectUsageStates = fallbackSettingsMap.get(NetworkConstants.SETTING_GEO_USAGE_STATUS)
  settingGeoObjectUsageState = new BehaviorSubject<any>(undefined)
  fallbackEventInvitationSiteReferral = fallbackSettingsMap.get(NetworkConstants.SETTING_EVENT_INVITATION_SITE_REFERRAL)
  settingEventInvitationSiteReferral = new BehaviorSubject<any>(undefined)
  fallbackReadOutGroup = fallbackSettingsMap.get(NetworkConstants.SETTING_READOUT_GROUPS)
  settingReadoutGroup = new BehaviorSubject<any>(undefined)
  fallbackUserRoles = fallbackSettingsMap.get(NetworkConstants.SETTING_USER_ROLES)
  settingUserRoles = new BehaviorSubject<any>(undefined)

  fallbackWorkOrderTypes = fallbackSettingsMap.get(NetworkConstants.SETTING_WORK_ORDER_TYPE)
  settingWorkOrderTypes = new BehaviorSubject<any>(undefined)

  mapToObserve = new Map([
    [NetworkConstants.SETTING_GR_LOCATION, this.settingsGameLocations],
    [NetworkConstants.SETTING_GR_STATUS, this.settingsGameStatus],
    [NetworkConstants.SETTING_LAB_SAMPLE_STATUS, this.settingsSampleStatus],
    [NetworkConstants.SETTING_LAB_SAMPLE_LOCATION, this.settingsSampleLocation],
    [NetworkConstants.SETTING_LAB_SAMPLE_TYPE, this.settingsSampleType],
    [NetworkConstants.SETTING_HUNTING_METHODS, this.settingHuntingMethods],
    [NetworkConstants.SETTING_COLLECTIVE_SPECIES, this.settingCollectiveSpecies],
    [NetworkConstants.SETTING_TROPY_TYPE, this.settingTrophyType],
    [NetworkConstants.SETTING_GR_MEAT_QUALITY, this.settingMeatQualitySubject],
    [NetworkConstants.SETTING_GR_SHOT_QUALITY, this.settingShotQualitySubject],
    [NetworkConstants.SETTING_UTILIZATION_OPTION, this.settingUtilizationOption],
    [NetworkConstants.SETTING_SPECIES, this.settingSpecies],
    [NetworkConstants.SETTING_GEO_TYPE, this.settingPoiType],
    [NetworkConstants.SETTING_GEO_CATEGORY, this.settingPoiCategory],
    [NetworkConstants.SETTING_GEO_LINE_TYPES, this.settingGeoObjectLineType],
    [NetworkConstants.SETTING_GEO_POLYGON_TYPES, this.settingGeoObjectPolygonType],

    [NetworkConstants.SETTING_GEO_USAGE_STATUS, this.settingGeoObjectUsageState],
    [NetworkConstants.SETTING_EVENT_INVITATION_SITE_REFERRAL, this.settingEventInvitationSiteReferral],
    [NetworkConstants.SETTING_READOUT_GROUPS, this.settingReadoutGroup],
    [NetworkConstants.SETTING_USER_ROLES, this.settingUserRoles], // NAR-5647
    [NetworkConstants.SETTING_WORK_ORDER_TYPE, this.settingWorkOrderTypes], 
  ])

  rightsPercontext:Map<string,any> = new Map([])
  superContext = new BehaviorSubject<boolean>(false)
  subContext = new BehaviorSubject<boolean>(false)
  superContextIds = new BehaviorSubject<boolean>(undefined)
  contextAndSubContextIds = new BehaviorSubject<any>(undefined)
  selectedContextAndSubContextIds = new BehaviorSubject<any>(undefined)

  constructor(
    private firestore: AngularFirestore,
    private transactionLogService: TransactionLogService,
    private userService: UserService,
    private userFeedBackService: UserFeedbackService
  ) {
  }

  observeData(contextId) {
    if (this.subbedContext == contextId) return 
    this.resetValues()
    // const sub = this.observeAllGamerecordsContext(contextId)
    this.mapToObserve.forEach((value, key) =>{
      if (this.subscriptions.get(key)) this.subscriptions.get(key).unsubscribe()
      const sub = this.observeSetting(key, contextId, value)
      this.subscriptions.set(key, sub)
    })
    this.observeAllDistrictReportings(contextId)
    this.subbedContext = contextId
  }

  private resetValues() {
    this.mapToObserve.forEach((value, key) => {
      value.next(undefined)
    })
    this.allReportingContexts$.next(undefined)
  }

  async removeSubs() {
    this.ngUnsubscribe.next()
    this.subbedContext = undefined
    this.resetValues()
    this.subscriptions.forEach(element => {
      element.unsubscribe()
      // element.remove()
    });
    return Promise.resolve()
  }

  observeSetting(settingId: string, contextId: string, behaviorSubject$: BehaviorSubject<any>): Subscription {
    const path = `${NetworkConstants.COLLECTION_CONTEXT}/${contextId}/${NetworkConstants.COLLECTION_SETTINGS}/${settingId}`
    const docRef = doc(this.Ifirestore, path);

    return docData(docRef)
      .pipe(
        distinctUntilChanged((prev, curr) => deepEqual(prev, curr)),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe({
        next: (data) => {
          if (data) {
            behaviorSubject$.next(data);
            if(data.values === "" || !data.values)
              data.values = []
            this.setNewContextSettingInContext(contextId, settingId, data);
          } else {
            // No data present fallback Werte...
            this.createFallbackSetting(settingId);
          }
        },
        error: (error) => {
          console.error(error);
        }
      });
  }

  updateSetting(oldSetting: any, newsetting: any): Promise<void> {
    return new Promise(async (resolve, reject) => {
      // const updates1 = buildCustomDiff(oldSetting, newsetting)
      const updates = diffObject(oldSetting, newsetting, {})
      const map = updatesToFirestoreUpdates(updates)
      // const mapNew = updatesToFirestoreUpdates(updates1)
      try {
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const context = this.selectedUserContext$.value
        const list = await this.transactionLogService.determineDiff(user, updates, newsetting.identifier, `${NetworkConstants.COLLECTION_CONTEXT}/${context.identifier}/${NetworkConstants.COLLECTION_SETTINGS}`)
        map['updateTimestamp'] = new Date()

        const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_CONTEXT, context.identifier, NetworkConstants.COLLECTION_SETTINGS,newsetting.identifier )
        await updateDoc( docRef, map)
        await this.transactionLogService.saveTransactionLog(list)
        resolve()
      } catch (error) {
        console.error(error)
        reject(error)
      }
    })
  }

  loadContextData(contextId ): Promise<ContextMembership>{
    return new Promise((resolve, reject) => {
      const baseRef = doc(this.Ifirestore,`${NetworkConstants.COLLECTION_CONTEXT}/${contextId}` )
      from(getDoc(baseRef)).pipe(timeout(this.timeoutInMil))
      .subscribe( {
        next:(baseQuery) => {
          if (baseQuery.exists()) {
            const data = baseQuery.data()
            const context = new ContextMembership()
            context.setFromAny(data)
            resolve(context)
          } else {
            resolve(undefined)
          }
        },
        error: (err) => {
          if (err.name === 'TimeoutError') {
            console.error('Request timed out ');
          } 
          console.error('sth failed context doc--->',err); 
          this.userFeedBackService.loading.emit(false);
          reject(err)
        },
        complete: () => {}
      })
    })
  }

  timeoutInMil = 90000

  setSelectedContextAndSubContextIds(ids) {
    const context = this.selectedUserContext$.value
    this.selectedContextAndSubContextIds.next(ids)
  }

  getSubcontextIds() {
    const ids = this.selectedContextAndSubContextIds.value ?? []
    const ctxId = this.selectedUserContext$.value?.identifier
    return (deepCopy(ids) ?? []).filter( c => c != ctxId)
  }

  loadUserContexts(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.userFeedBackService.loading.emit(true)
      this.userService.user$.pipe(skipWhile(el => !el), take(1))
        .subscribe({
          next : (user: FirestoreUser) => {

            const baseRef = doc(this.Ifirestore,`${NetworkConstants.COLLECTION_CONTEXT}/${user.contextId}` )
            const base = from(getDoc(baseRef))

            base.pipe(timeout(this.timeoutInMil))
              .subscribe({
                next: async (result: any) => {
                  this.userFeedBackService.loading.emit(true)
                  // if (result.length != 2) reject('Error unexpected data.')
                  let map: Map<string, ContextMembership> = new Map()
                  let settingsMap: Map<string, any> = new Map()
                  const baseQuery = result
                  // const collContexts = result[1]
                  if (baseQuery.exists()) {
                    const data = baseQuery.data()
                    const context = new ContextMembership()
                    const _data = Object.assign({}, user, data)
                    delete _data.identifier
                    context.setFromAny(_data)
                    try {
                      const map = await context.getContextSettings(this.firestore)
                      settingsMap.set(context.identifier, map)
                      await context.getContextModules(this.firestore)
                    } catch (error) {
                      console.error(error)
                    }
                    map.set(context.identifier, context)
                  }
                  if(user.contextMembership){
                    const collContexts = Object.entries(user.contextMembership)//result[1]
                    if (collContexts.length != 0) {// !collContexts.empty
                      await new Promise((r, rej) => {
                        this.userFeedBackService.loading.emit(true)
                        let index = 0
                        const items = collContexts.length
                        collContexts.forEach(async (element) => {
                          const data:any = element[1]//element.data()
                          const identifier:any = element[0]//element.data()
                          const contextData = await this.loadContextData(identifier)
                          if (!contextData) return;
                          data.huntingEventManagement = contextData.huntingEventManagement ? contextData.huntingEventManagement : undefined
                          const _data = Object.assign({}, data, contextData)
                          // const context = new ContextMembership()
                          // context.setFromAny(data)
                          contextData.setFromAny(data)
                          try {
                            const map = await contextData.getContextSettings(this.firestore)
                            settingsMap.set(contextData.identifier, map)
                            await contextData.getContextModules(this.firestore)
  
                          } catch (error) {
                            console.error(error)
                          }
                          map.set(contextData.identifier, contextData)
                          index +=1
                          if (index == items) r(undefined)
                        });
                      })
                      this.userFeedBackService.loading.emit(false)
                    }
                  }else
                    this.loadUserContextsFromContMemberships(user)
                  
                  let list: ContextMembership[] = []
                  map.forEach((value, key) => {
                    value.settingsMap = settingsMap.get(key)
                    this.loadContextRightsPerRole(value)
                    if(!value.invitationState || value?.invitationState == 'accepted')
                    list.push(value)}
                  )
                  this.allUserContexts$.next(list)
                  resolve()
                },
                error: (err) => {
                  if (err.name === 'TimeoutError') console.error('Request timed out ');
                  console.error('sth failed --->',err); 
                  this.userFeedBackService.loading.emit(false);
                  reject(err)
                },
                complete: () => { this.userFeedBackService.loading.emit(false)}
              })
          },
          error: (error) => {
            console.error('error-->',error)
            this.userFeedBackService.loading.emit(false)
            reject(error)
          },
          complete: () => {}
        })

    })

    // this.userService.user$.pipe(skipWhile(el => !el), take(1))
    //     .subscribe({
    //       next : (user: FirestoreUser) => {
    //         const baseRef = doc(this.Ifirestore,`${NetworkConstants.COLLECTION_CONTEXT}/${user.contextId}` )
    //         const othersRef = collection(this.Ifirestore,`${NetworkConstants.COLLECTION_USER}/${user.identifier}/${NetworkConstants.COLLECTION_CONTEXT_MEMBERSHIP}` )

    //         const base = from(getDoc(baseRef))
    //         const others = from(getDocs(othersRef))

    //         forkJoin([base, others]).pipe(timeout(this.timeoutInMil))
    //           .subscribe({
    //             next: async (result: any[]) => {
    //               this.userFeedBackService.loading.emit(true)
    //               if (result.length != 2) reject('Error unexpected data.')
    //               let map: Map<string, ContextMembership> = new Map()
    //               const baseQuery = result[0]
    //               const collContexts = result[1]
    //               if (baseQuery.exists) {
    //                 const data = baseQuery.data()
    //                 const context = new ContextMembership()
    //                 const _data = Object.assign({}, user, data)
    //                 delete _data.identifier
    //                 context.setFromAny(_data)
    //                 try {
    //                   await context.getContextSettings(this.firestore)
    //                   await context.getContextModules(this.firestore)
    //                 } catch (error) {
    //                   console.error(error)
    //                 }
    //                 map.set(context.identifier, context)
    //               }

    //               if (!collContexts.empty) {
    //                 await new Promise((r, rej) => {
    //                  this.userFeedBackService.loading.emit(true)
    //                   let index = 0
    //                   const items = collContexts.docs.length
    //                   collContexts.forEach(async (element) => {
    //                     const data = element.data()
    //                     const contextData = await this.loadContextData(element.id)
    //                     data.huntingEventManagement = contextData.huntingEventManagement ? contextData.huntingEventManagement : undefined

    //                     const context = new ContextMembership()
    //                     context.setFromAny(data)
    //                     try {
    //                       await context.getContextSettings(this.firestore)
    //                       await context.getContextModules(this.firestore)

    //                     } catch (error) {
    //                       console.error(error)
    //                     }
    //                     map.set(context.identifier, context)
    //                     index +=1
    //                     if (index == items) r(undefined)
    //                   });
    //                 })
    //                 this.userFeedBackService.loading.emit(false)
    //               }
    //               let list: ContextMembership[] = []
    //               map.forEach((value, key) => {
    //                 if(!value.invitationState || value?.invitationState == 'accepted')
    //                 list.push(value)}
    //               )

    //               this.allUserContexts$.next(list)
    //               resolve()
    //             },
    //             error: (err) => {
    //               if (err.name === 'TimeoutError') {
    //                 console.error('Request timed out ');
    //               } 
    //               console.error('sth failed --->',err); 
    //               this.userFeedBackService.loading.emit(false);
    //               reject(err)
    //             },
    //             complete: () => { this.userFeedBackService.loading.emit(false)}

    //             }
    //           )
    //       },
    //       error: (error) => {
    //         console.error('error-->',error)
    //         this.userFeedBackService.loading.emit(false)
    //         reject(error)
    //       },
    //       complete: () => {}
    //     })
  }

  loadUserContextsFromContMemberships(user: FirestoreUser){
    const othersRef = collection(this.Ifirestore,`${NetworkConstants.COLLECTION_USER}/${user.identifier}/${NetworkConstants.COLLECTION_CONTEXT_MEMBERSHIP}` )
    const others = from(getDocs(othersRef))
    others.pipe(timeout(this.timeoutInMil))
    .subscribe({
      next: async (result: any) => {
        let map: Map<string, ContextMembership> = new Map()
        let list: ContextMembership[] = []
        let settingsMap: Map<string, any> = new Map()

        if(this.allUserContexts$.value){
          list = this.allUserContexts$.value
          list.forEach( ctx => {
            map.set(ctx.identifier, ctx)
          })
        }
        
        this.userFeedBackService.loading.emit(true)

        if (!result.empty) {
          await new Promise((r, rej) => {
            this.userFeedBackService.loading.emit(true)
            let index = 0
            const items = result.docs.length
            result.docs.forEach(async (element) => {
              const data = element.data()
              const contextData = await this.loadContextData(element.id)
              if (contextData) return;
              data.huntingEventManagement = contextData.huntingEventManagement ? contextData.huntingEventManagement : undefined

              const context = new ContextMembership()
              context.setFromAny(data)
              try {
                const map = await context.getContextSettings(this.firestore)
                settingsMap.set(context.identifier, map)
                await context.getContextModules(this.firestore)
              } catch (error) {
                console.error(error)
              }
              map.set(context.identifier, context)
              index +=1
              if (index == items) r(undefined)
            });
          })
        }

        map.forEach((value, key) => {
          value.settingsMap = settingsMap.get(key)
          if((!value.invitationState || value?.invitationState == 'accepted') && !list.some(ctx => ctx.identifier === value.identifier))
          list.push(value)}
        )

        this.allUserContexts$.next(list)
      },
      error: (err) => {
        if (err.name === 'TimeoutError') console.error('Request timed out ');
        console.error('sth failed --->',err); 
        this.userFeedBackService.loading.emit(false);
      },
      complete: () => { this.userFeedBackService.loading.emit(false)}
    })
  }

  observeAllDistrictReportings(contextId: string) {
    const path = NetworkConstants.COLLECTION_DISTRICT_REPORTING
    const ref = collectionGroup(this.Ifirestore, path)
    const q = query(ref, where('reportingContextId', '==', contextId))
      
    collectionData(q).pipe(takeUntil(this.ngUnsubscribe)).subscribe({
        next: (elements) => {
          let list: DistrictReporting[] = []
          elements?.forEach((element: any) => {
            const reporting = element as DistrictReporting
            list.push(reporting)
          })
          this.allReportingContexts$.next(list)
        },
        error: (error) => {
          console.error(error)
        }
      })
  }

  setNewContextSettingInContext(contextId: string, settingId: string, setting: any) {
    const allContexts = this.allUserContexts$.value
    const selectedContext = this.selectedUserContext$.value
    // for selectedContext
    if (selectedContext.identifier == contextId) {
      selectedContext.settingsMap.set(settingId, setting)
    }
    // for allContexts
    const ctx = allContexts?.find(el => el.identifier == contextId)
    ctx?.settingsMap.set(settingId, setting)
    // if (ctx) this.allUserContexts$.next(allContexts)

  }

  private async createFallbackSetting(settingId: string): Promise<void> {
    // return new Promise(async (resolve, reject) => {
      console.log('----createFallbackSetting----', settingId)
      const context = this.selectedUserContext$.value
      const fallback = fallbackSettingsMap.get(settingId)
      
      var fallbackValues:any = []
      if(fallback){
        fallbackValues = fallback.values
      }
      const setting = {
        identifier: settingId,
        contextId: context.identifier,
        updateTimestamp: new Date(),
        _structureVersion: "1.0",
        values: fallbackValues
      }
      
      try {

        const ref = doc(this.Ifirestore, NetworkConstants.COLLECTION_CONTEXT, context.identifier, NetworkConstants.COLLECTION_SETTINGS, settingId );
        setDoc(ref, setting, { merge: true });

        // await this.firestore.collection(NetworkConstants.COLLECTION_CONTEXT).doc(context.identifier).collection(NetworkConstants.COLLECTION_SETTINGS).doc(settingId).set(setting)
        // resolve()
      } catch (error) {
        console.error("heeeereeeee", error)
        // reject(error)
      }
    // })
  }

  loadContextRightsPerRole(value: ContextMembership) {
    // console.log('--------loadContextRightsPerRole------', value.identifier, value.settingsMap)
    let rights = {}
    const entities = ['start', 'dashboard', 'dashcadenza', 'contextsettings', 'objects', 'invitation', 'statistics', 'map', NetworkConstants.COLLECTION_GAMERECORD, NetworkConstants.COLLECTION_POI, NetworkConstants.COLLECTION_WORK_ORDER]
    if (value.identifier) {
      const context = value
      // Collections whose access is configured per role in the dataAccess dialog.
      const dataAccessCollections = [
        NetworkConstants.COLLECTION_POI,
        NetworkConstants.COLLECTION_GAMERECORD,
        NetworkConstants.COLLECTION_WORK_ORDER,
        NetworkConstants.COLLECTION_HUNTING_DISTRICT,
        NetworkConstants.COLLECTION_LABSAMPLE,
        NetworkConstants.COLLECTION_PERSON,
        NetworkConstants.COLLECTION_USER,
      ]
      const grantedByBuiltInRole = new Set<string>()

      if (context.roles) {
        context.roles.forEach( role => {
          if (rightsPerRole[role]) {
            Object.assign(rights, rightsPerRole[role])
            dataAccessCollections.forEach(c => {
              if (rightsPerRole[role]?.[c]) grantedByBuiltInRole.add(c)
            })

            const hdRights: any = rights[NetworkConstants.COLLECTION_HUNTING_DISTRICT]
            if (hdRights?.C && hdRights.E === undefined) hdRights.E = true
            if (hdRights?.C && hdRights.I === undefined) hdRights.I = true
          } else {
            const userRoles = context.settingsMap.get(NetworkConstants.SETTING_USER_ROLES)?.values ? (isArray(context.settingsMap.get(NetworkConstants.SETTING_USER_ROLES)?.values) ? context.settingsMap.get(NetworkConstants.SETTING_USER_ROLES)?.values : []) :  []
            // console.log('userRoles', userRoles)
            const userRolesIdent = (deepCopy(userRoles) ?? []).map(r => r.identifier)
            const commonItems = (deepCopy(context.roles) ?? []).filter(item => userRolesIdent.includes(item));
            const commonRole = (deepCopy(userRoles) ?? []).filter(item => commonItems.includes(item.identifier));
            const access = commonRole.filter(r => r?.appAccess?.includes('cockpit') )
            // console.log('access', access)

            access.forEach(el => {
              if(el.appAccess) {
                el.appAccess.forEach( ap => {
                  Object.assign(rights, rightsPerRole[ap])
                })
              }
            })

            dataAccessCollections.forEach(c => {
              if (!grantedByBuiltInRole.has(c)) delete rights[c]
            })

            access.forEach(el => {
              if(el.dataAccess) {
                el.dataAccess.forEach( ap => {
                  // Create, Read, Update, Delete, Export, Import, MultiEdit
                  const actions:any = ['C','R','U','D','E','I','M']
                  const present = new Set(ap.rights.map(s => s[0].toUpperCase()));
                  const result = Object.fromEntries( actions.map(k => [k, present.has(k)]) );
                  const access = {[ap.collection]: result}
                  // console.log(ap.collection)

                  if (ap.collection === NetworkConstants.COLLECTION_CTX_SETTINGS) {
                    access[NetworkConstants.ROUTE_CTX_SETTINGS] = access[NetworkConstants.COLLECTION_CTX_SETTINGS] 
                  }

                  if(ap.filters)
                    access[ap.collection].filters = ap.filters
                  Object.assign(rights, access)
                })
              }
            });
          }
        })
      }
      this.rightsPercontext.set(value.identifier, rights)
      // console.log(this.rightsPercontext)
    }
  }
}
